export enum UserManagementActions {
  resetPassword = 'resetPassword',
  recoverEmail = 'recoverEmail',
  verifyEmail = 'verifyEmail',
}

export enum loginPageText {
  loginHeading = 'Welcome !',
  forgotHeading = 'Forgot Password',
  resetHeading = 'New Password',
  subHeading = 'Welcome to Montra Electric ! To get started, please log in with your credentials. Have a great time using our application!',
}
